export const SUPPORTED_LANGUAGES = [
  { code: 'en', flag: '🇬🇧', title: 'English' },
  { code: 'it', flag: '🇮🇹', title: 'Italiano' },
  { code: 'fr', flag: '🇫🇷', title: 'Français' },
  { code: 'de', flag: '🇩🇪', title: 'Deutsch' },
  { code: 'es', flag: '🇪🇸', title: 'Español' },
  {
    code: 'pt-BR',
    flag: '🇧🇷',
    title: 'Português',
    subtitle: '(Brasil)',
  },
  {
    code: 'pt-PT',
    flag: '🇵🇹',
    title: 'Português',
    subtitle: '(Portugal)',
  },
  { code: 'pl', flag: '🇵🇱', title: 'Polski' },
  { code: 'cs', flag: '🇨🇿', title: 'Čeština' },
  { code: 'ja', flag: '🇯🇵', title: '日本語' },
] as const

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code']

export const DEFAULT_LANGUAGE: LanguageCode = 'en'

export function backendToAppLanguage(backendCode: string): LanguageCode {
  switch (backendCode.toLowerCase()) {
    case 'br':
      return 'pt-BR'
    case 'pt':
      return 'pt-PT'
    case 'pl':
      return 'pl'
    case 'cs':
      return 'cs'
    case 'ja':
      return 'ja'
    default:
      return SUPPORTED_LANGUAGES.find((l) => l.code === backendCode)
        ? (backendCode as LanguageCode)
        : DEFAULT_LANGUAGE
  }
}

export function appToBackendLanguage(appCode: LanguageCode): string {
  switch (appCode) {
    case 'pt-BR':
      return 'br'
    case 'pt-PT':
      return 'pt'
    case 'pl':
      return 'pl'
    case 'cs':
      return 'cs'
    case 'ja':
      return 'ja'
    default:
      return appCode
  }
}
